import React, { useState, useRef } from 'react';
import block from 'bem-cn';
import debounce from 'lodash.debounce';
import crossSVG from 'shared/img/cross.svg';

import SVG from 'components/SVG';

import './InputSearch.scss';

const b = block('input-search');

const InputSearch = ({
  value,
  name,
  callBack,
  placeholder = '',
  size = 'default',
  type = 'text',
  isRequired,
  onChange,
  color,
  ...props
}) => {
  const [tempSearch, setTempSearch] = useState(value);

  const debouncedSearch = useRef(debounce(value => {
    onChange(value);
  }, 1000));

  const handleSearchChange = value => {
    setTempSearch(value);
    debouncedSearch.current(value);
  }

  return (
    <div className={b('wrapper')}>
      <input
        type="search"
        name={name}
        value={tempSearch}
        placeholder={placeholder || ''}
        onChange={e => handleSearchChange(e.currentTarget.value)}
        className={b({ sizable: size, type, color })}
        required={isRequired}
        {...props}
      />
      <span className={b('cross-container')} style={{ opacity: value ? 1 : 0 }} onClick={() => handleSearchChange('')}>
        <SVG className={b('cross')} svgProps={{ svg: crossSVG }} />
      </span>
    </div>
  );    
};

export default InputSearch;
